import slugify from 'react-slugify';
import franchiseData from '~/data/franchiseApiData.json';

export const getColors = (slug?: string) => {
  const slugifiedName = slugify(slug ?? '');
  
  // First try to find the team in the franchise data
  const franchise = franchiseData.data.find(
    (team) => slugify(team.teamName) === slugifiedName
  );

  if (franchise) {
    return {
      bg: franchise.bgColor,
      primary: franchise.primaryColor,
      action: franchise.actionColor,
    };
  }

  // If not found in franchise data, use the fallback switch case for special teams
  switch (slugifiedName) {
    // all star teams
    case 'team-blue':
      return {
        bg: '#1C9AD6',
        primary: '#1C9AD6',
        action: '#000',
      };
    case 'team-orange':
      return {
        bg: '#FF8F28',
        primary: '#FF8F28',
        action: '#000',
      };
    case 'team-gold':
      return {
        bg: '#DAAA00',
        primary: '#DAAA00',
        action: '#000',
      };
    case 'team-purple':
      return {
        bg: '#8C4799',
        primary: '#8C4799',
        action: '#FFF',
      };

    case 'none':
      return {
        bg: '#7A7A7A',
        primary: '#7A7A7A',
        action: '#FFF',
      };

    // free agent
    default:
      return {
        bg: '#0C2136',
        primary: '#ff8300',
        secondary: '#000000',
        action: '#fff',
      };
  }
};

export const getTeamByColor = (color: string) => {
  switch (color) {
    case '#1C9AD6':
      return { color: '#1C9AD6', name: 'Team Blue' };
    case '#FF8F28':
      return { color: '#FF8F28', name: 'Team Orange' };
    case '#DAAA00':
      return { color: '#DAAA00', name: 'Team Gold' };
    case '#8C4799':
      return { color: '#8C4799', name: 'Team Purple' } ;
    default:
      return { color: '#7A7A7A', name: 'AUSL' };
  }
};
